/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-11 10:34:58
 */
import { createApp, onMounted } from 'vue'
import { createPinia } from 'pinia';
import './style.css'
import App from './App.vue'
import AntdDesignVue from 'ant-design-vue'
import * as AntIcons from '@ant-design/icons-vue'
import 'ant-design-vue/dist/antd.variable.min.css';
import Router from './router.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import i18n from '@/i18n/index.js';
import directive from './directive/index'; // 统一自定义指令入口

NProgress.inc(0.4)
NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false})

const app = createApp(App)

const PiniaStore = createPinia()

// 注册组件
Object.keys(AntIcons).forEach(key => {
    app.component(key, AntIcons[key])
})
// 添加到全局
app.config.globalProperties.$antIcons = AntIcons

directive(app)

app.use(Router)
app.use(PiniaStore)
app.use(AntdDesignVue)
app.use(i18n)


app.mount('#app')

Router.beforeEach((to, from, next) => {
    console.log(to, from,'to, from')
    NProgress.start();
    console.log(to.path === '/Login', 'kkkkk')
    if(to.path === '/Login') {
        console.log('jin 111')
        // if(localStorage.getItem("loginUser")){
        //     console.log('jin 222')
        //     next() 
        // } else{
            next() 
        // }
    }
    // else if(to.path === '/Login' && localStorage.getItem("loginUser")){
    //     console.log('jin 222')
    //     next() 
    // } 
    else {
        console.log('jin 333',to.meta.requiresAuth && !localStorage.getItem('hd_ota_loginUser'))

        if(to.meta.requiresAuth && !localStorage.getItem('hd_ota_loginUser')) { //未登录，则路由定向到 登录路由
            next({ path: '/Login' })
        }else { //不需要登录验证，或者已经登录成功
            next() 
        }
    }
});
Router.afterEach(() => {
    NProgress.done();
});
